export const environment = { apiURL: '/api/', hubURL: '/hubs/ops', label: 'DEV', version: '1.0.0' };
